/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-14 09:25:32
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import DataViewApi, {DataViewDOI} from "./api/dataViewApi";
import DataViewService from "./service/dataViewService";
import './dataView.less';
import { createBEM, createNamespace } from 'src/util/bem';
import QueryForm from 'src/components/queryForm/queryForm';
import override from "../../../dectorators/override";
import Tab from 'src/components/tab/tab';
import Button from 'src/types/iview/Button';
import FileUtil from 'src/util/fileUtil';
let bem = createBEM('data-view')

@Component({name: 'data-manage-data-view'})
export default class DataView extends BasicSearchPage<DataViewService, DataViewDOI.RowDataI, DataViewDOI.QueryRowDataParamsI> {

    className: string = bem()

    pageShow = false


    currentDataType: string = ''
    dataType: {name: string, value: string}[] = []

    tabChange(value) {
        this.search()
    }
    async export() {
        let {code, data} = await DataViewApi.exportAll()
        if(code === 0) {
            FileUtil.download(data.download_url)
        }
    }
    renderQuery(h) {
		return <div class={bem('query')}>
            <Tab dataSource={this.dataType} v-model={this.currentDataType} on-change={this.tabChange.bind(this)}></Tab>
            <div class={bem('query-form')}>
                <QueryForm ref="queryForm" dataSource={this.queryFormData} on-search={this.search} showClear={false}/>
                <Button class={createNamespace('mb5')} type="info" on-click={this.export.bind(this)}>导出</Button>
            </div>
        </div>
    }

    @override
    renderHead(h) {
        return <div></div>
    }
    
    async mounted () {
        await this.service.queryDataType()
		this.service.initSearchParams()
		this.searchTable()
	}

	@override
	loadService () {
		this.service = new DataViewService(this)
	}
}